export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const HANDLE_LOGIN_SUCCESS = 'HANDLE_LOGIN_SUCCESS';
export const HANDLE_LOGIN_ERROR = 'HANDLE_LOGIN_ERROR';
export const IS_EXPORT_EXCEL = 'IS_EXPORT_EXCEL';
export const IS_EXPORT_EXCEL_CONTRACT = 'IS_EXPORT_EXCEL_CONTRACT';
export const CHECK_ALL_CONTRACT = 'CHECK_ALL_CONTRACT';
export const CHANGE_GRID_FILTER_CONTRAT = 'CHANGE_GRID_FILTER_CONTRAT';
export const CHANGE_GRID_FILTER = 'CHANGE_GRID_FILTER';
export const CHANGE_GRID_FILTER_FACTURATION = 'CHANGE_GRID_FILTER_FACTURATION';
export const END_VALID_CALCUL = 'END_VALID_CALCUL';
